import {FetchResult} from 'apollo-link';
import {map} from 'rxjs/operators';

export const extractData = <T extends { [V in K]: U }, U, K extends keyof T>(key: K) => map((result: FetchResult<T>) => result.data[key]);
